import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

export const StepbystepApplicationStepEstimatedMileage: React.FC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>How many miles are on the vehicle you are refinancing?</StepTitle>
    <ApplicationField product={Product.Loan} field={Fields.EstimatedMileage} />
  </Wrapper>
)
